import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import './ManageUsersDetails.scss'
import UserModal from "./UserModal";
import UserModules from "./UserModules/UserModules";
import Spinner from "./_common/Spinner";

const ManageUsersDetails = props => {
    const {user, handleClearDeviceIdsClick, handleResetPasswordClick,superAdmin} = props;
    const t = useSelector(state => state.language.translator);
    const [pending, setPending] = useState(true)
    const [tab, setTab] = useState('details')

    useEffect(() => {
        setPending(true)
        setTab('details')
        setTimeout(() => setPending(false), 200)
    },[user])

    if(pending) {
        return (
            <div className='spinnerWrapper'>
                <Spinner size={300} />
            </div>
        )
    }
    return (
        <div className="ManageUsersDetails">
            {superAdmin && user &&
                <div className='manageUsersDetailsTabs' role='tablist'>
                    <button type='button' role='tab' aria-selected={tab === 'details'} onClick={() => setTab('details')}>
                        {t.gettext('Details')}
                    </button>
                    <button type='button' role='tab' aria-selected={tab === 'modules'} onClick={() => setTab('modules')}>
                        {t.gettext('Modules')}
                    </button>
                </div>
            }
            {tab === 'modules' && superAdmin && user
                ? <UserModules userId={user.id}/>
                : <UserModal
                    superAdmin={superAdmin}
                    edit
                    user={user}
                    details
                    handleClearDeviceIdsClick={handleClearDeviceIdsClick}
                    handleResetPasswordClick={handleResetPasswordClick}
                />
            }
        </div>
    )
}

export default ManageUsersDetails
